import React from "react";
import { Text, View } from "react-native";

import { cap1stChar } from "../services/CommonUtils";
import { getItemSavingPercent, getMRP, getOfferPrice, getUnitPrice } from "../services/oms/OMSUtils";

import { IconView } from "./CommonWidget/Icons";
import { AddItemToCartPrimaryView, UpsertCartItemView } from "./UpsertCartItemView";

import { IndiaRupee } from "../constants/AppConstants";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

export const CartItemView = (props) => {
    const cartItem = props.item
    const textSize = props.textStyle ?? TextStyle.text16b

    let showUnitPrice = props?.showUnitPrice ?? false
    if (!showUnitPrice && cartItem?.mrp?.su && cartItem?.mrp?.su > 1) showUnitPrice = true

    const updateCartItem = props.updateCartItem
    const openAddQuantityModal = props.openAddQuantityModal
    return (<View style={[AppStyles.bgWhite, AppStyles.px16, AppStyles.py16, { width: AppTheme.appWidth, paddingRight: 16 }]}>

        {/* onPress={() => console.log('### item data: ', cartItem)} */}
        <Text style={[textSize, {
            width: AppTheme.appWidth - 64, flexWrap: "wrap",
        }]}>{cartItem?.productName ?? cartItem?.name}</Text>

        <Text style={[TextStyle.text14, AppStyles.mt4, {
            width: AppTheme.appWidth - 64,
        }]} numberOfLines={1}>{cartItem?.packSizeLabel}</Text>

        {cartItem?.rxRequired && <View style={[AppStyles.flexRowStart, AppStyles.mt4]}>
            <IconView icon={'erx_orange.svg'} width={11} height={12} />
            <Text style={[TextStyle.text12, TextStyle.colorGrey, AppStyles.pl8]}>
                Requires Prescription</Text>
        </View>}

        <View style={[AppStyles.flexRowSpaceBetween, AppStyles.mb16, { marginTop: showUnitPrice ? 8 : 16 }]}>
            {showUnitPrice ? <View>
                <Text style={[TextStyle.text14b, TextStyle.colorPrimary]}>
                    {IndiaRupee} {getUnitPrice(cartItem)}</Text>
                {/* {cartItem['packSizeLabel'] ? <Text style={[TextStyle.text12, { color: AppTheme.color.green.primary }]}>
                    {cap1stChar(cartItem['packSizeLabel'])}</Text> : null} */}
            </View> : <View style={[AppStyles.flexRowStart]}>
                <Text style={[TextStyle.text14b]}>{IndiaRupee} {getOfferPrice(cartItem)}</Text>
                {!!getMRP(cartItem) ? <Text style={[TextStyle.text12, TextStyle.lineThrough, TextStyle.alignCenter,
                { marginLeft: 4, color: AppTheme.color.grey.fillerInfo }]}>{IndiaRupee} {getMRP(cartItem)}</Text> : null}
                {!!getItemSavingPercent(cartItem) ? <Text style={[TextStyle.text12b, { marginLeft: 4, color: AppTheme.color.green.primary }]}>
                    {getItemSavingPercent(cartItem)}</Text> : null}
            </View>}


            {!!cartItem.quantity ? <UpsertCartItemView item={cartItem} updateCartItem={updateCartItem} /> :
                <AddItemToCartPrimaryView item={cartItem} action={openAddQuantityModal} />}

        </View>
    </View>
    )
}